import React from 'react';
import styles from './Conferences.module.css';

interface Speaker {
  src: string;
  name: string;
  title: string;
  company: string;
}

const speakers: Speaker[] = [
  {
    src: '/assets/images/speaker-iman.png',
    name: 'Iman Deschâtres',
    title: 'Founder',
    company: 'DEPTAX',
  },
  {
    src: '/assets/images/speaker-sandrine.png',
    name: 'Sandrine Le Cam',
    title: 'CMO Associée',
    company: 'DATA ENSO',
  },
  {
    src: '/assets/images/speaker-amal.png',
    name: 'Amal Dopchie',
    title: 'Directrice Practice DCX',
    company: 'RHAPSODIES CONSEIL',
  },
  {
    src: '/assets/images/speaker-rudy.png',
    name: 'Rudy Abitbol',
    title: 'Founder & Expert eCommerce B2B',
    company: 'HUMANAFTERALL.CA',
  },
  {
    src: '/assets/images/speaker-xaviere.png',
    name: 'Xaviere Tallent',
    title: 'Global Offer Leader for Commerce, Agentic Commerce & Sales',
    company: 'CAPGEMINI',
  },
  {
    src: '/assets/images/speaker-emmanuelle.png',
    name: 'Emmanuelle Evette',
    title: 'Directrice Conseil - Head of eCommerce',
    company: 'VML CONSULTING',
  },
];

const Conferences: React.FC = () => {
  return (
    <section
      className={styles.section}
    >
      <div className={styles.container}>
        <div className={styles.left}>
          <img
            src="/assets/images/conference-illustration.jpg"
            alt="Conference illustration"
            className={styles.illustration}
          />
        </div>
        <div className={styles.right}>
          <h2 className={styles.title}>CONFÉRENCES ET INVITÉS B2B AMBITIEUX :</h2>
          <p className={styles.description}>
            Assistez à des conférences animées par des acteurs clés du B2B : dirigeants, experts et
            innovateurs viennent partager leur vision, leurs retours d'expérience et les grandes
            tendances qui transforment durablement les modèles B2B.
          </p>
          <div className={styles.speakers}>
            {speakers.map((speaker, index) => (
              <div key={index} className={styles.speaker}>
                <img
                  src={speaker.src}
                  alt={speaker.name}
                  className={styles.speakerImage}
                />
                <div className={styles.speakerName}>{speaker.name}</div>
                <div className={styles.speakerTitle}>{speaker.title}</div>
                <div className={styles.speakerCompany}>{speaker.company}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Conferences;
